module.exports = __webpack_public_path__ + "static/media/organizer_6.68172a8e.jpg";